<template>
  <p class="tito-ticket-details--postpone-answers-question">
    <a href="#" @click.prevent="postponeAnswers = true" v-if="!postponeAnswers">
      {{ $t("views.tickets._form.survey.opt_out_text", locale) }}
    </a>
    <a href="#" @click.prevent="postponeAnswers = false" v-else>{{
      $t("views.tickets._form.survey.can_answer_question_now", locale)
    }}</a>
  </p>
</template>

<script>
export default {
  props: ["locale"],

  data() {
    return {
      postponeAnswers: false,
    };
  },

  watch: {
    postponeAnswers() {
      this.$emit("input", this.postponeAnswers);
    },
  },
};
</script>
